import React from 'react';

interface TripDayItemProps {
  children?: React.ReactNode;
}

export default function TripDayItem({ children }: TripDayItemProps) {
  return (
    <div className="h-full relative overflow-hidden p-2.5 bg-gradient-to-t from-white/40 to-white border rounded-md">
      {children}
    </div>
  );
}
